import { useState } from 'react';
import DiceLogo from './DiceLogo';
import InvitePlayersModal from './modals/InvitePlayersModal';

export default function GameLobbyView({ gameCode, gameId, players, allUsers, hostName, onStart, onCancel, onInvite, sentInvites }) {
  const [copied, setCopied] = useState(false);
  const [showInvite, setShowInvite] = useState(false);

  function copyLink() {
    const link = `${window.location.origin}/?game=${gameCode}`;
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      alert(link);
    });
  }

  return (
    <div id="game-lobby-view">
      <DiceLogo />

      <h2 className="lobby-title">share the code</h2>

      <div className="lobby-code-display">
        <span className="lobby-code">{gameCode}</span>
      </div>

      <p className="lobby-subtitle">players can enter this code to join the game</p>

      <div className="lobby-action-row">
        <button className="lobby-copy-btn" onClick={copyLink}>
          {copied ? 'Copied!' : 'Copy Link'}
        </button>
        <button className="lobby-copy-btn" onClick={() => setShowInvite(true)}>
          Invite Players
        </button>
      </div>

      <div className="lobby-players">
        <div className="input-label">{players.length} player{players.length !== 1 ? 's' : ''} ready</div>
        {players.map((p, i) => (
          <div key={p.id} className="setup-player-card">
            <div className="avatar">{p.avatar}</div>
            <span>{p.name}</span>
            {i === 0 && <span className="host-badge">host</span>}
            {p.lastTurn === 'Joined!' && i > 0 && <span className="joined-badge">joined</span>}
          </div>
        ))}
      </div>

      <div className="lobby-waiting">
        <div className="lobby-waiting-dots">
          <span></span><span></span><span></span>
        </div>
        <p className="lobby-waiting-text">waiting for players...</p>
      </div>

      <div className="lobby-footer">
        <button className="btn-bank" disabled={players.length < 2} onClick={onStart}>
          {players.length < 2 ? 'Need at least 2 players' : "Let's Roll!"}
        </button>
        <button className="btn-quit" style={{ marginTop: 10 }} onClick={onCancel}>Cancel Game</button>
      </div>

      <InvitePlayersModal
        show={showInvite}
        onClose={() => setShowInvite(false)}
        allUsers={allUsers}
        players={players}
        onInvite={onInvite}
        sentInvites={sentInvites || []}
      />
    </div>
  );
}
